import { connect } from 'react-redux';
import { compose } from 'redux';
import { authenticationModule, AuthenticationState } from 'modules/shared/redux';

import { RedirectToPersonalSpaceStateProps, RedirectToPersonalSpaceOwnProps } from './redirect-to-personal-space-type';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (states: any): RedirectToPersonalSpaceStateProps => {
    const subState = states[authenticationModule.storeName] as AuthenticationState;
    return {
        folder: subState.loggedInFolder ? subState.loggedInFolder : undefined,
    };
};

const enhancer = compose<React.ComponentType<RedirectToPersonalSpaceOwnProps>>(
    connect<RedirectToPersonalSpaceStateProps, RedirectToPersonalSpaceOwnProps, null>(mapStateToProps),
);
export default enhancer;
